var map = {
	"./_settings.scss": 1443,
	"./base/_alert-boxes.scss": 1444,
	"./base/_badges.scss": 1445,
	"./base/_base.scss": 1446,
	"./base/_cw-footer.scss": 1447,
	"./base/_fonts.scss": 1448,
	"./base/_forms.scss": 1449,
	"./base/_grid.scss": 1450,
	"./base/_layout.scss": 1451,
	"./base/_lightbox.scss": 1452,
	"./base/_modal.scss": 1453,
	"./base/_nav-bar.scss": 1454,
	"./base/_normal_font.scss": 117,
	"./base/_offcanvas.scss": 1455,
	"./base/_pagination.scss": 1456,
	"./base/_panels.scss": 1457,
	"./base/_sharing.scss": 1458,
	"./base/_switches.scss": 1459,
	"./base/_tables.scss": 1460,
	"./base/_tooltips.scss": 1461,
	"./base/_type.scss": 1462,
	"./base/_video.scss": 1463,
	"./base/_visibility.scss": 1464,
	"./base/buttons/_all.scss": 1465,
	"./base/buttons/_mixins.scss": 1466,
	"./base/buttons/_sharing.scss": 1467,
	"./base/forms/_checkboxes.scss": 1468,
	"./base/forms/_input-combos.scss": 1469,
	"./base/forms/_non-text.scss": 1470,
	"./base/forms/_text-fields.scss": 1471,
	"./base/nav-bar/_base-with-links.scss": 1472,
	"./base/nav-bar/_base.scss": 1473,
	"./base/nav-bar/_fade.scss": 1474,
	"./base/nav-bar/_inverted.scss": 1475,
	"./base/nav-bar/_large-up.scss": 1476,
	"./components/_hero.scss": 1477,
	"./pages/accounts.scss": 1478,
	"./pages/admin.scss": 1479,
	"./pages/admin/grants.scss": 1480,
	"./pages/admin/offline_donations.scss": 1481,
	"./pages/asset_generator.scss": 1482,
	"./pages/authorization.scss": 1483,
	"./pages/birthdays.scss": 1484,
	"./pages/campaigns.scss": 1485,
	"./pages/donations.scss": 1486,
	"./pages/donations/_donate-form.scss": 1487,
	"./pages/donations/_hidden-campaign.scss": 1488,
	"./pages/donations/_sponsor-recognition.scss": 1489,
	"./pages/donations/_thank-you.scss": 1490,
	"./pages/donations/components/_ach-popout-form.scss": 1491,
	"./pages/donations/components/_apple-pay-button.scss": 1492,
	"./pages/donations/components/_browser-fallback.scss": 1493,
	"./pages/donations/components/_donate-buttons.scss": 1494,
	"./pages/donations/components/_donate-by-check-modal.scss": 1495,
	"./pages/donations/components/_donation-form-inputs.scss": 1496,
	"./pages/donations/components/_gift_aid.scss": 1497,
	"./pages/donations/components/_iho.scss": 1498,
	"./pages/donations/components/_offscreen-donate-components.scss": 1499,
	"./pages/donations/components/_stripe-elements.scss": 1500,
	"./pages/donations/dynamic.scss": 1501,
	"./pages/donations/general.scss": 1502,
	"./pages/donations/gift-the-spring.scss": 1503,
	"./pages/donations/in-honor-of.scss": 1504,
	"./pages/donations/sponsor.scss": 1505,
	"./pages/donations/the-spring-new.scss": 1506,
	"./pages/donations/thespring.scss": 1507,
	"./pages/edit_mailing_list_subscriber.scss": 1508,
	"./pages/exceptions.scss": 1509,
	"./pages/founders.scss": 1510,
	"./pages/mailing-list-subscribers.scss": 1511,
	"./pages/partners.scss": 1512,
	"./pages/premium_impact_profile.scss": 1513,
	"./pages/profile/bps_membership.scss": 1514,
	"./pages/profile/lifetime_impact.scss": 1515,
	"./pages/profile/my_projects.scss": 1516,
	"./pages/profile/shared.scss": 1517,
	"./pages/profile/spring_membership.scss": 1518,
	"./pages/profile/user_private.scss": 1519,
	"./pages/profile/user_public.scss": 1520,
	"./pages/projects/_country_icons.scss": 1521,
	"./pages/projects/projects.scss": 1522,
	"./pages/redeem-the-spring.scss": 1523,
	"./pages/search.scss": 1524,
	"./pages/september-campaign/_modal.scss": 1525,
	"./pages/september_2020.scss": 1526,
	"./pages/static_pages/about.scss": 1527,
	"./pages/static_pages/brand_partnerships.scss": 1528,
	"./pages/static_pages/company_match.scss": 1529,
	"./pages/static_pages/company_match_iframe.scss": 1530,
	"./pages/static_pages/completed_projects.scss": 1531,
	"./pages/static_pages/css_docs.scss": 1532,
	"./pages/static_pages/education.scss": 1533,
	"./pages/static_pages/error.scss": 1534,
	"./pages/static_pages/financials.scss": 1535,
	"./pages/static_pages/fundraise.scss": 1536,
	"./pages/static_pages/gala_dashboard.scss": 1537,
	"./pages/static_pages/get_involved.scss": 1538,
	"./pages/static_pages/home.scss": 1539,
	"./pages/static_pages/hundred_percent_model.scss": 1540,
	"./pages/static_pages/in_kind_donations.scss": 1541,
	"./pages/static_pages/internships.scss": 1542,
	"./pages/static_pages/jobs.scss": 1543,
	"./pages/static_pages/kids.scss": 1544,
	"./pages/static_pages/local_partners.scss": 1545,
	"./pages/static_pages/media.scss": 1546,
	"./pages/static_pages/mission.scss": 1547,
	"./pages/static_pages/our_approach.scss": 1548,
	"./pages/static_pages/our_projects.scss": 1549,
	"./pages/static_pages/our_work.scss": 1550,
	"./pages/static_pages/privacy.scss": 1551,
	"./pages/static_pages/scott_harrison_story.scss": 1552,
	"./pages/static_pages/scotts_story.scss": 1553,
	"./pages/static_pages/sensors.scss": 1554,
	"./pages/static_pages/staff.scss": 1555,
	"./pages/static_pages/the_pool.scss": 1556,
	"./pages/static_pages/volunteer.scss": 1557,
	"./pages/static_pages/water_crisis_learn.scss": 1558,
	"./pages/static_pages/whywater.scss": 1559,
	"./pages/stories.scss": 1560,
	"./pages/subscriptions.scss": 1561,
	"./pages/the_spring_series.scss": 1562,
	"./pages/thirst/thirst.scss": 1563,
	"./pages/tributary.scss": 1564,
	"./pages/uk/about.scss": 1565,
	"./pages/uk/partnerships.scss": 1566,
	"./pages/uk/privacy.scss": 1567,
	"./pages/uk/uk.scss": 1568,
	"./pages/unpledge.scss": 1569,
	"./pages/video_landing_page.scss": 1570,
	"./pages/wwd/community.scss": 1571,
	"./pages/wwd/discover.scss": 1572,
	"./pages/wwd/explore.scss": 1573,
	"./pages/wwd/profile.scss": 1574,
	"./pages/wwd/shared.scss": 1575,
	"./pages/wwd/welcome.scss": 1576,
	"./patterns/action-tiles.scss": 1577,
	"./patterns/avatar-initial.scss": 1578,
	"./patterns/cards.scss": 1579,
	"./patterns/clamp-for-ellipsis.scss": 1580,
	"./patterns/cw-icon-spin.scss": 1581,
	"./patterns/dashed-elements.scss": 1582,
	"./patterns/full-bottom-bg.scss": 1583,
	"./patterns/image-fill.scss": 1584,
	"./patterns/latest-update-indicator.scss": 1585,
	"./patterns/leading-image-block.scss": 1586,
	"./patterns/module.scss": 1587,
	"./patterns/progress.scss": 1588,
	"./patterns/side-by-side.scss": 1589,
	"./patterns/split-bg-block.scss": 1590,
	"./patterns/tabs.scss": 1591,
	"./patterns/text-separator.scss": 1592,
	"./patterns/yellow-underlined.scss": 1593,
	"./react-components/completed-projects-map.scss": 1594,
	"./react-components/email-capture-modal.scss": 1595,
	"./react-components/journey-player.scss": 1596,
	"./react-components/mailing-list-intercept-modal.scss": 1597,
	"./react-components/people-served-input.scss": 1598,
	"./react-components/september-campaign.scss": 1599,
	"./settings/_colors.scss": 1600,
	"./settings/_general.scss": 1601,
	"./settings/_media-queries.scss": 1602,
	"./settings/_mixins.scss": 1603,
	"./settings/_type.scss": 1604,
	"./shared/breadcrumbs.scss": 1605,
	"./shared/clipboard-button.scss": 1606,
	"./shared/comments.scss": 1607,
	"./shared/cookie_banner.scss": 1608,
	"./shared/datepicker.scss": 1609,
	"./shared/fixed-banner.scss": 1610,
	"./shared/geosuggest.scss": 1611,
	"./shared/grecaptcha.scss": 1612,
	"./shared/hide-donate-links.scss": 1613,
	"./shared/intl-tel-input.scss": 1614,
	"./shared/mailing-list-form.scss": 1615,
	"./shared/mailing-list-sign-up-button.scss": 1616,
	"./shared/mobile-donate-banner.scss": 1617,
	"./shared/parsley.scss": 1618,
	"./shared/percy.scss": 1619,
	"./shared/public_campaign_card_details.scss": 1620,
	"./shared/simple-form.scss": 1621,
	"./shared/sly-quiz.scss": 1622,
	"./shared/spring_logo_svg.scss": 1623,
	"./shared/spring_mark_svg.scss": 1624,
	"./shared/spring_series_seasons.scss": 1625,
	"./shared/video-box-container.scss": 1626,
	"./tailwinds.scss": 255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1442;